var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-container", class: ["col-" + _vm.colSize] },
    [
      _vm.title
        ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _c(
          "div",
          { staticClass: "form-group-material form-group-material-no-label" },
          [
            _c("date-section", {
              attrs: {
                value: _vm.value,
                type: _vm.type,
                placeholder: _vm.placeholder,
                calendar: "",
                disabled: _vm.disabled,
                readonly: _vm.readOnly,
              },
              on: { change: _vm.handleChange },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }